<template>
  <promo-transition>
    <div>
      <v-container fluid>
        <v-container fluid class="paddingSecondContainer">
          <v-layout wrap pt-3>
            <v-flex md12>
              <div class="chat-container">
                <div class="body">
                  <div class="table">
                    <chat-log ref="chatlog"></chat-log>
                    <message-input :idIncidencia="this.incidencia.id" :detalleIncidencia="this.incidencia" ></message-input>
                  </div>
                </div>
              </div>
            </v-flex>
        </v-layout>


          </v-container>
      </v-container>

    </div>
  </promo-transition>
</template>

<script>
import ChatLog from '@/components/chat/ChatLog'
import MessageInput from '@/components/chat/MessageInput'
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'chat-container',
  components: {
    ChatLog,
    MessageInput
  },
  props: {
    incidencia: {}
  },
  data () {
    return {
      titulo: '',
      idIncidencia: 0
    }
  },
  mounted () {

    this.$pnClean(this.canalAnterior)
    const codigoIdubapi = this.idubapi.idubapi
    const canal = 'idubapi_' + codigoIdubapi + 'incidencia_' + this.incidencia.id
    this.idIncidencia = this.incidencia.id
    this.titulo = this.incidencia.description
    this.accionCambiarCanal(canal)
    this.$pnSubscribe({
      channels: [canal],
      withPresence: true
    })
  },
  computed: {
    ...mapGetters({
      uuid: 'getMyUuid',
      idubapi: 'login/idubapi',
      canal: 'chat/getCanal'
    }),
    canal () {
      if (this.$store.state.chat.canal) {
        return this.$store.state.chat.canal
      }
      return 'vueChat'
    },
    canalAnterior () {
      if (this.$store.state.chat.canalAnterior) {
        return this.$store.state.chat.canalAnterior
      }
      return 'vueChat'
    }
  },
  methods: {
    ...mapActions({
      accionCambiarCanal: 'chat/cambiarCanal'
    })
  }
}
</script>

<style scoped>
h1 {
  display: table-cell;
  vertical-align: middle;
  margin: 0;
  font-size: 16px;
  font-weight: normal;
}

.chat-container {
  display: table;
  min-width: 300px;
  width: 100%;
  height: calc(80vh - 120px);
  margin: auto;
  background-color: #FFFFFF;
  border: solid 1px #BFBFBF;
  border-radius: 3px;
}

.heading {
  display: table;
  width: 100%;
  height: 28px;
  text-align: center;
  background-color: #CDCDCD;
  border-radius: 3px 3px 0 0;
  -ms-user-select: none;
  user-select: none;
  background: linear-gradient(#EDEDED 0%, #CDCDCD 75%);
}

.body {
  display: block;
  width: auto;
  height: inherit;
  overflow: hidden;
}

.table {
  display: table;
  width: 100%;
  height: 100%;
}
</style>
